import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CustomerdosService } from 'src/app/services/customerdos/customerdos.service';
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { CustomersService } from 'src/app/services/customer/customer.service';
import { cityService } from 'src/app/services/city/city.service';
import { SettingService } from 'src/app/services/setting/setting.service';
import { MasterdosService } from 'src/app/services/masterdos/masterdos.service';
import { SalesService } from 'src/app/services/sales/sales.service';

@Component({
    selector: 'app-exportModal',
    templateUrl: './exportModal.component.html',
    styleUrls: ['./exportModal.component.scss']
})
export class exportModalComponent implements OnInit {
    @Input() props: any;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();

    public title: string;
    public subTitle: string;
    public fromData: any;

    public type: string;
    public data: any;
    public page: any = 1;
    public isBtnLoaded = false;
    public customerlistForDropdown: any;
    public isCustomerDropdown: any;
    public showError: any;
    public userType: any;
    public  login_customer_id: any;
    public providerListForDropdown: any;
    public customer_id: any;
    public provider_id: any=0;
    public isAggregator=false;
    isAggregator1: boolean;

    constructor(
        private ngbModal: NgbActiveModal,
        private toastr: ToastrService,
        private customerdosService: CustomerdosService,
        private authService: AuthenticationService,
        private customerService: CustomersService,
        private cityService: cityService,
        private salesService: SalesService,
        private SettingService:SettingService,
        private masterdosService:MasterdosService

    ) {
        // this.userType= this.authService.user.roles[0].user_type_id;
        this.userType= 2;
        this.login_customer_id= this.authService.user.customer_id; }

    ngOnInit(): void {
        this.setDialogProps(this.props);

        this.customerdosService.getallCustomer().subscribe((data) => {
            this.customerlistForDropdown = data.data;
        });
        if(this.userType==1)
        {

         this.getProvidersData(this.login_customer_id);
        }
        if(this.isCustomerDropdown=='no')
      {
       this.getProvidersData(this.customer_id);
      }

    }

    setDialogProps(dialogdata: any) {
        this.title = dialogdata.title;
        this.subTitle = dialogdata.subTitle;
        this.type = dialogdata.type;
        this.data = dialogdata.data;
        this.page = dialogdata.page;
        this.isCustomerDropdown = dialogdata.isCustomerDropdown;
        this.customer_id = dialogdata.customer_id;

    }


    // selectOption(id: any) {
    //     this.customer_id=id;
    //     this.fromData = { customer_id: this.customer_id,provider_id:this.provider_id }

    //     this.getProvidersData(id);

    // }
    // selectProviderOption(id: any) {
    //     if(this.userType==1)
    //     {
    //         this.fromData = { customer_id:this.login_customer_id ,provider_id:id }

    //     }else{
    //         this.fromData = { customer_id: this.customer_id,provider_id:id }

    //     }
    // }
    getProvidersData(myvalue){
        this.customerService.getAggregatorProvider(myvalue).subscribe((data) => {
            this.providerListForDropdown = data.data;
        });

        this.customerdosService.getSingleCustomer(myvalue).subscribe((data) => {

            if(data.data.is_aggregator == 'true')
            {
                this.isAggregator1 =true;
            }else{
                this.isAggregator1 =false;

            }

        });

    }


    onDownload() {


        switch (this.type) {

            // case 'downloadDosCustomer':
            //     this.customer_id=1;
            //     this.fromData = { customer_id: this.customer_id,provider_id:this.provider_id }

            //     this.getProvidersData(1);
            //     if(this.fromData==undefined)
            //     {

            //         this.fromData = { customer_id:this.customer_id}

            //     }
            //
            //     if (this.fromData) {

            //         this.showError = false;
            //         this.isBtnLoaded = true;
            //         this.customerdosService.downloadDos(this.fromData).subscribe(
            //             (res: any) => {
            //                 if (res && res.success) {
            //                     this.toastr.success(`${res.message}`);
            //                    // window.open(res.data, "_blank");
            //                 } else {
            //                     if (res.message) {
            //                         this.toastr.error(`${res.message}`);
            //                     } else {
            //                         this.toastr.error(`Update failed`);
            //                     }
            //                 }
            //                 this.isBtnLoaded = false;
            //             },
            //             (err: any) => {
            //                 this.toastr.error(`${err.statusText}`);
            //
            //             }
            //         );
            //     }else{
            //         this.showError = true;
            //     }
            //     break;
            case 'downloadDos':
                if(this.fromData==undefined)
                {

                    this.fromData = { customer_id:this.login_customer_id}

                }
                if (this.fromData) {

                    this.showError = false;
                    this.isBtnLoaded = true;
                    this.customerdosService.downloadDos(this.fromData).subscribe(
                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success(`${res.message}`);
                               window.open(res.data, '_blank');
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Update failed`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.toastr.error(`${err.statusText}`);

                        }
                    );
                }else{
                    this.showError = true;
                }
                break;
                case 'downloadMasterDos':
                    if(this.fromData==undefined)
                    {

                        this.fromData = { customer_id:this.login_customer_id}

                    }
                    if (this.fromData) {

                        this.showError = false;
                        this.isBtnLoaded = true;
                        this.masterdosService.downloadDos(this.fromData).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                   window.open(res.data,'_blank');
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                    } else {
                                        this.toastr.error(`Update failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.toastr.error(`${err.statusText}`);

                            }
                        );
                    }else{
                        this.showError = true;
                    }
                    break;
                case 'downloadCity':
                    if(this.fromData==undefined)
                    {

                        this.fromData = { customer_id:this.login_customer_id}

                    }
                    if (this.fromData) {

                        this.showError = false;
                        this.isBtnLoaded = true;
                        this.cityService.downloadCity().subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                   window.open(res.data, '_blank');
                                   this.onClose();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                    } else {
                                        this.toastr.error(`Update failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.toastr.error(`${err.statusText}`);

                            }
                        );
                    }else{
                        this.showError = true;
                    }
                    break;
                    case 'downloadAreaCode':
                        if(this.fromData==undefined)
                        {

                            this.fromData = { customer_id:this.login_customer_id}

                        }
                        if (this.fromData) {

                            this.showError = false;
                            this.isBtnLoaded = true;
                            this.SettingService.downloadAreaCode().subscribe(
                                (res: any) => {
                                    if (res && res.success) {
                                        this.toastr.success(`${res.message}`);
                                       window.open(res.data, '_blank');
                                       this.onClose();

                                    } else {
                                        if (res.message) {
                                            this.toastr.error(`${res.message}`);
                                        } else {
                                            this.toastr.error(`Update failed`);
                                        }
                                    }
                                    this.isBtnLoaded = false;
                                },
                                (err: any) => {
                                    this.toastr.error(`${err.statusText}`);

                                }
                            );
                        }else{
                            this.showError = true;
                        }

                        break;
                        case 'downloadPinCode':
                            if(this.fromData==undefined)
                            {

                                this.fromData = { customer_id:this.login_customer_id}

                            }
                            if (this.fromData) {

                                this.showError = false;
                                this.isBtnLoaded = true;
                                this.SettingService.downloadPincode().subscribe(
                                    (res: any) => {
                                        if (res && res.success) {
                                            this.toastr.success(`${res.message}`);
                                           window.open(res.data, '_blank');
                                           this.onClose();

                                        //    window.location.href = res.data;
                                        } else {
                                            if (res.message) {
                                                this.toastr.error(`${res.message}`);
                                            } else {
                                                this.toastr.error(`Update failed`);
                                            }
                                        }
                                        this.isBtnLoaded = false;
                                    },
                                    (err: any) => {
                                        this.toastr.error(`${err.statusText}`);

                                    }
                                );
                            }else{
                                this.showError = true;
                            }

                            break;
                            case 'downloadProspect':
                                if(this.fromData==undefined)
                                {

                                    this.fromData = { customer_id:this.login_customer_id}

                                }
                                if (this.fromData) {

                                    this.showError = false;
                                    this.isBtnLoaded = true;
                                    this.salesService.DownloadProspect().subscribe(
                                        (res: any) => {
                                            if (res && res.success) {
                                                this.toastr.success(`${res.message}`);
                                               window.open(res.data, '_blank');
                                               this.onClose();

                                            } else {
                                                if (res.message) {
                                                    this.toastr.error(`${res.message}`);
                                                } else {
                                                    this.toastr.error(`Update failed`);
                                                }
                                            }
                                            this.isBtnLoaded = false;
                                        },
                                        (err: any) => {
                                            this.toastr.error(`${err.statusText}`);

                                        }
                                    );
                                }else{
                                    this.showError = true;
                                }

                                break;
                                case 'downloadClient':
                                    if(this.fromData==undefined)
                                    {

                                        this.fromData = { customer_id:this.login_customer_id}

                                    }
                                    if (this.fromData) {

                                        this.showError = false;
                                        this.isBtnLoaded = true;
                                        this.salesService.DownloadClient().subscribe(
                                            (res: any) => {
                                                if (res && res.success) {
                                                    this.toastr.success(`${res.message}`);
                                                   window.open(res.data, '_blank');
                                                   this.onClose();

                                                } else {
                                                    if (res.message) {
                                                        this.toastr.error(`${res.message}`);
                                                    } else {
                                                        this.toastr.error(`Update failed`);
                                                    }
                                                }
                                                this.isBtnLoaded = false;
                                            },
                                            (err: any) => {
                                                this.toastr.error(`${err.statusText}`);

                                            }
                                        );
                                    }else{
                                        this.showError = true;
                                    }

                                    break;
                                case 'downloadSalesRep':
                                    if(this.fromData==undefined)
                                    {

                                        this.fromData = { customer_id:this.login_customer_id}

                                    }
                                    if (this.fromData) {

                                        this.showError = false;
                                        this.isBtnLoaded = true;
                                        this.salesService.DownloadSalesRep(this.data).subscribe(
                                            (res: any) => {
                                                if (res && res.success) {
                                                    this.toastr.success(`${res.message}`);
                                                   window.open(res.data, '_blank');
                                                   this.onClose();
                                                } else {
                                                    if (res.message) {
                                                        this.toastr.error(`${res.message}`);
                                                    } else {
                                                        this.toastr.error(`Update failed`);
                                                    }
                                                }
                                                this.isBtnLoaded = false;
                                            },
                                            (err: any) => {
                                                this.toastr.error(`${err.statusText}`);

                                            }
                                        );
                                    }else{
                                        this.showError = true;
                                    }

                                    break;
                                    case 'downloadReport':
                                        if(this.fromData==undefined)
                                        {

                                            this.fromData = { customer_id:this.login_customer_id}

                                        }
                                        if (this.fromData) {

                                            this.showError = false;
                                            this.isBtnLoaded = true;
                                            this.salesService.DownloadReport(this.data).subscribe(
                                                (res: any) => {
                                                    if (res && res.success) {
                                                        this.toastr.success(`${res.message}`);
                                                        window.open(res.data, '_blank');
                                                       this.onClose();
                                                    } else {
                                                        if (res.message) {
                                                            this.toastr.error(`${res.message}`);
                                                        } else {
                                                            this.toastr.error(`Update failed`);
                                                        }
                                                    }
                                                    this.isBtnLoaded = false;
                                                },
                                                (err: any) => {
                                                    this.toastr.error(`${err.statusText}`);

                                                }
                                            );
                                        }else{
                                            this.showError = true;
                                        }

        }
    }

    onClose() {
        this.passEntry.next(this.page);
        this.ngbModal.close();
    }
}
